<template>
    <el-dialog
            title="关联所属组织"
            width="80%"
            :close-on-click-modal="false"
            :visible.sync="view.visible">
        <el-table :default-expand-all="true" :data="dataList" row-key="id" ref="dataTable" size="small" border style="width: 100%;" :tree-props="{children: 'children', hasChildren: 'hasChildren'}" @selection-change="selectionChangeHandle">
            <el-table-column
                    type="selection"
                    header-align="center"
                    align="center"
                    width="50">
            </el-table-column>
            <el-table-column
                    type="index"
                    width="50"
                    label="序号">
            </el-table-column>
            <el-table-column
                    prop="orgCode"
                    header-align="left"
                    align="left"
                    label="编码">
            </el-table-column>
            <el-table-column
                    prop="orgName"
                    header-align="left"
                    align="left"
                    label="名称">
            </el-table-column>
            <el-table-column prop="tenantName" header-align="left" align="left" min-width="100" label="租户">
            </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="view.visible = false">取消
      </el-button>
      <el-button size="small" type="primary" @click="dataFormSubmit()">确定
      </el-button>
    </span>
    </el-dialog>
</template>

<script>
    import {fetchOrgForMainBody, fetchOrgForTenant, assignOrgForUser} from '@/controller/sys'
    export default {
        data() {
            return {
                dataList: [],
                dataListSelections: [],
                dataListLoading: false,
                multiSelection: [],
                view: {
                    visible: false,
                    conheight: {
                        height: this.$store.state.common.documentClientDefaultHeight * 0.9 - 410 + 'px',
                        'overflow-y': 'auto'
                    }
                },
                viewData: {},
                dataForm: {
                    id: 0
                }
            }
        },
        methods: {
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },
            init(id, orgIds) {
                this.dataForm.id = id || 0
                this.view.visible = true
                this.dataListLoading = true
                if(this.$store.state.user.userInfo.typeId === 2){
                    fetchOrgForTenant.then(data => {
                        this.dataList = data.body
                        this.dataListLoading = false
                        this.$nextTick(() => {
                            this.multiSelection = orgIds
                            this.initMultiSelection(this.dataList)
                        })
                    })
                }else {
                    fetchOrgForMainBody({},sessionStorage.getItem('mainBodyId')).then(data => {
                        this.dataList = data.body
                        this.dataListLoading = false
                        this.$nextTick(() => {
                            this.multiSelection = orgIds
                            this.initMultiSelection(this.dataList)
                        })
                    })
                }

            },
            initMultiSelection(rows) {
                rows.forEach((row) => {
                    this.multiSelection.forEach((id) => {
                        if (parseInt(row.id) === id) {
                            this.$refs.dataTable.toggleRowSelection(row, true)
                        }
                    })
                    if (row.children.length > 0) {
                        this.initMultiSelection(row.children)
                    }
                })
            },
            // 表单提交
            dataFormSubmit() {
                let insertIds = []
                let deleteIds = []
                this.dataListSelections.forEach(item => {
                    let isNew = true
                    this.multiSelection.forEach(selection => {
                        if(parseInt(selection) === parseInt(item.id)){
                            isNew = false
                            return
                        }
                    })
                    if(isNew){
                        insertIds.push(item.id)
                    }
                })
                // console.log('multiSelection='+this.multiSelection);
                this.multiSelection.forEach(item => {
                    // console.log('multiSelection_item='+item);
                    let isOld = true
                    this.dataListSelections.filter(selection => {
                        if(parseInt(selection.id) === parseInt(item)){
                            isOld = false
                            return
                        }
                    })
                    if(isOld){
                        // deleteIds.push(item.permissionId)
                        deleteIds.push(item)
                    }
                })
                // console.log('insertIds='+insertIds);
                // console.log('deleteIds='+deleteIds);
                assignOrgForUser(
                    {
                        'userId': this.dataForm.id || undefined,
                        'insertIds': insertIds,
                        'deleteIds': deleteIds
                    }
                ).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.view.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            }
        }
    }
</script>
